import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs/Subject'
import { Component } from '@angular/core';
import { $BroadcastManagerService } from '../../BroadcastManager.service';
import { ModalData } from '../ModalData';

@Component({
    selector: 'app-modal.prompt-entity',
    templateUrl: 'modal.prompt-entity.html'
})
export class ModalPromptEntityComponent {
    public onClose : Subject<boolean>
    public modalDataObj: ModalData;
public ngOnInit() : void {
    this.onClose= new Subject();

}
    constructor(
        public bsModalRef: BsModalRef,
        private $: $BroadcastManagerService
    ) { }
public onConfirm() :void {
    this.onClose.next(true);
    this.bsModalRef.hide();
    console.log("Clicked Ok")
}
public onCancel() :void {
    this.onClose.next(false);
    this.bsModalRef.hide();
    console.log("Clicked Cancel")
}
    // emitEv(name: string): void {
    //     this.$.emit({
    //         click: name
    //     });
    //     this.bsModalRef.hide();
    // }
}
